const testimonials = [
  {
    name: "Lt. Col. Sarah W.",
    location: "Offutt AFB, NE",
    rating: 5,
    text: "Received STRATCOM TDY orders to Stuttgart with 16 days notice. My husband's passport was expired and our daughter needed her first one. Fast Passport Center walked us through everything, reviewed all documents, and got both passports back in six business days. That is the difference between making a STRATCOM mission and missing it. Absolutely recommend to every Offutt family.",
    service: "Family Expedited Passports",
  },
  {
    name: "Michael T.",
    location: "Aksarben, Omaha",
    rating: 5,
    text: "I work in reinsurance and had a client meeting in London with two weeks notice. My passport expired during COVID when I was not traveling. Fast Passport Center had my renewal processed and back to me in five business days. I flew out of Eppley without any issues. Professional, efficient, and worth every dollar.",
    service: "Passport Renewal",
  },
  {
    name: "Rachel & Tom H.",
    location: "Millard, Omaha",
    rating: 5,
    text: "We planned a family trip to Germany to visit relatives for months, then discovered a week before that our son's passport expired and our daughter never had one. Called Fast Passport Center, they guided us through the child passport process, reviewed everything, and we had both in seven business days. Made our flight. The team was so patient and thorough.",
    service: "Family Passport Services",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function OmahaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Nebraska Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Omaha, Offutt AFB, and Millard travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}